import $ from 'jquery';

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that
 * may exist. Also updates the master select and triggers updates when the
 * variants price or image changes.
 *
 * @namespace variants
 */
export default function slateVariant() {

	var $product_form = document.querySelector('.add-to-cart-form');
	var	$add_to_cart = document.getElementById('addCartBtn');
	var previousInputValue;
	var clickedRound = 1;
	var globalTrackVariant;
	var currentSelectedSize;
	var currentSelectedGender;
	var currentVariant;
	
	slate.Variants = (function() {

		/**
		 * Variant constructor
		 *
		 * @param {object} options - Settings from `product.js`
		 */
		
		function Variants(options) {
			this.$container = options.$container;
			this.product = options.product;
			this.singleOptionSelector = options.singleOptionSelector;
			this.originalSelectorId = options.originalSelectorId;
			this.enableHistoryState = options.enableHistoryState;
			this.currentVariant = this._getVariantFromOptions();

			$(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this, this.singleOptionSelector));
		}

		Variants.prototype = $.extend({}, Variants.prototype, {

			/**
			 * Get the currently selected options from add-to-cart form. Works with all
			 * form input elements.
			 *
			 * @return {array} options - Values of currently selected variants
			 */
			_getCurrentOptions: function() {
				var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
					var $element = $(element);
					var type = $element.attr('type'); 
					var currentOption = {};

					if (type === 'radio' || type === 'checkbox') {
						if ($element[0].checked) {
							currentOption.value = $element.val();
							currentOption.index = $element.data('index');
							return currentOption;
						} else {
							return false;
						}
					} else {
						currentOption.value = $element.val();
						currentOption.index = $element.data('index');
						return currentOption;
					}
				});

				// remove any unchecked input values if using radio buttons or checkboxes
				currentOptions = slate.utils.compact(currentOptions);

				return currentOptions;
			},

			/**
			 * Find variant based on selected values.
			 *
			 * @param  {array} selectedValues - Values of variant inputs
			 * @return {object || undefined} found - Variant object from
			 *   product.variants
			 */
			_getVariantFromOptions: function() {
				// console.log(this.__getCurrentOptions(), 12345);
				var selectedValues = this._getCurrentOptions();
				var variants = this.product.variants;
				var found = false;

				variants.forEach(function(variant) {
					var satisfied = true;

					selectedValues.forEach(function(option) {
						if (satisfied) {
							satisfied = (option.value === variant[option.index]);
						}
					});

					if (satisfied) {
						found = variant;
					}
				});				
				// console.log(window.oppGenderProduct, 12)
				// console.log(window.variantsExtension, 13)

				// catch any sizes that do not exist as actual products
				if (this.product.title.includes('Women')) {
					currentSelectedSize = selectedValues[2].value;
					currentSelectedGender = 'Women';
					switch (selectedValues[2].value) {
						case '9.5':
							return { 
								size: 9.5, 
								gender: 'female', 
							}
						case '10':
							return { 
								size: 10, 
								gender: 'female',
							}
						case '10.5':
							return { 
								size: 10.5, 
								gender: 'female',
							}
						case '11':
							return { 
								size: 11, 
								gender: 'female',
							}
						case '11.5':
							return { 
								size: 11.5, 
								gender: 'female',
							}
						case '12':
							return { 
								size: 12, 
								gender: 'female',
							}
						case '12.5':
							return { 
								size: 12.5,
								gender: 'female',
							}
						case '13':
							return { 
								size: 13, 
								gender: 'female',
							}
						default:
							return found || null;
					}
				} else {
					currentSelectedSize = selectedValues[2].value;
					currentSelectedGender = 'Men';
					switch (selectedValues[2].value) {
						case '5':
							return { 
								size: 5,
								gender: 'male',
							}
						case '5.5':
							return { 
								size: 5.5, 
								gender: 'male',
							}
						case '6':
							return { 
								size: 6, 
								gender: 'male',
							}
						case '6.5':
							return { 
								size: 6.5, 
								gender: 'male',
						}
						case '7':
							return { 
								size: 7, 
								gender: 'male',
							}
						case '7.5':
							return { 
								size: 7.5, 
								gender: 'male',
							}
						default:
							return found || null;
					}
				}
			},

			/**
			 * Event handler for when a variant input changes.
			 */
			_onSelectChange: function(e) {
	      		$add_to_cart.classList.add('btn--disabled');
	      		console.log('Disable class added');
				const scope = this;
				const sizeTextElem = $('.variant.selected')
				// either returns a variant or an object representing a fake implant
				let variant = this._getVariantFromOptions();
				currentVariant = variant;
				// disable cart submit temporarily
				//$add_to_cart.style.pointerEvents = 'none';

				// remove left over line item properties
				if (document.querySelector('input[name="properties[size]"]')) document.querySelector('input[name="properties[size]"]').remove();
				if (document.querySelector('input[name="properties[pre-order]"]')) document.querySelector('input[name="properties[pre-order]"]').remove();
				if (document.querySelector('input[name="properties[_linkWithInsole]"]')) document.querySelector('input[name="properties[_linkWithInsole]"]').remove();

				// set genders and sizes
				let newInputValue;
				let fake_gender = ''; // gender of current product page
				let real_gender = ''; // gender from which the real shoe size will be returned
				let fake_size = 0; // set fake size based on whether object returned is variant or custom
				let real_size = 0; // fake size +/- 1.5
				!variant.hasOwnProperty('size') ? real_size = variant.option3 : fake_size = variant.size;
				if (variant.hasOwnProperty('gender')) {
					switch (variant.gender) {
						case 'female':
							fake_gender = 'men';
							real_gender = 'women';
							real_size = (parseFloat(fake_size) - 1.5);
							break;
						case 'male':
							fake_gender = 'women';
							real_gender = 'men';
							real_size = (parseFloat(fake_size) + 1.5);
							break;
					}
				}
				if (variant.hasOwnProperty('title') && variant.title.includes('Women')) {
					fake_gender = 'men';
					real_gender = 'women';
					fake_size = (parseFloat(real_size) - 1.5);
				}
				if (variant.hasOwnProperty('title') && variant.title.includes('Men')) {
					fake_gender = 'women';
					real_gender = 'men';
					fake_size = (parseFloat(real_size) + 1.5);
				}

				// create line item property
				let line_item_text = document.createElement('input');
			
				$('.c-pdp__sizeText').text(`US ` + `${sizeTextElem[0].innerText}`)
				if (variant.hasOwnProperty('gender')) {
					create_line_item(line_item_text, 'properties[size]', fake_gender + ' / ' + real_size + ' - ' + real_gender + ' / ' + fake_size);

				} else {
					create_line_item(line_item_text, 'properties[size]', real_gender + ' / ' + real_size + ' - ' + fake_gender + ' / ' + fake_size);
				}				
				//Keep track of browser not updating 
				// newInputValue = fake_gender + ' / ' + real_size + ' - ' + real_gender + ' / ' + fake_size
				
				// if(newInputValue === previousInputValue && clickedRound !== 1){
				// 	alert('Something went wrong, please refresh your browser')
				// 	$add_to_cart.classList.add('btn--disabled');
				// 	return ''
				
				// } else if (clickedRound === 1) {
				// 	previousInputValue = fake_gender + ' / ' + real_size + ' - ' + real_gender + ' / ' + fake_size
				// 	clickedRound += 1
				
				// } else {
				// 	previousInputValue = newInputValue
				// }

				// limit items in cart to 4 (impure global function)
				//quantity_limiter();
				// the user has selected a custom variant
				if (variant.hasOwnProperty('size')) {
					// gender swap for url
					let twin_handle = '';
					variant.gender == 'female' ? twin_handle = current_handle.replace('women', 'men') : twin_handle = current_handle.replace('men', 'women');

					const product_id = window.oppGenderProduct.id;
					const productVariant = window.oppGenderProduct.variants.find(each => each.option3 == real_size)
					if(productVariant){
						delete productVariant.inventory_policy
						delete productVariant.inventory_management
						trigger_update(scope, productVariant, twin_handle);
			
						// add da-restock form to form
						if (!productVariant.available) {
							let da_form = document.createElement('div');
							setTimeout(function () {
								document.querySelectorAll('.da-restock-notification').forEach(function (el) {
									el.style.display = 'none';
								});
								create_darestock_form(da_form, productVariant.id, product_id, '/products/' + twin_handle);
							}, 1000);
						}
						// check pre-order status
						let custom_el = document.querySelector('.no-js option[value="' + productVariant.id + '"]');
						preorder_check(productVariant, custom_el.getAttribute('data-quantity'));
					}
					// hide previous custom da-restock form when custom variants selected in succession
					setTimeout(function () {
						document.querySelectorAll('.da-restock-notification').forEach(function (el) {
							el.style.display = 'none';
						});
					}, 1000);
				}

				if (!variant.hasOwnProperty('size')) {
					preorder_check(variant, variant.inventory_quantity);
					trigger_update(scope, variant, false);
				}

				function preorder_check (c_variant, qty) {
					if (c_variant.available && qty <= 0) {
						setTimeout(function () {
							document.querySelector('[data-add-to-cart-text]').innerHTML = 'pre-order';
							document.querySelector('.add-to-cart-form .pre-order-note').style.display = 'block';
							let preOrderEstimate = $('.pre-order-note').first().text();
							let line_item_preorder = document.createElement('input');
							let lineItemProrderEstimate = document.createElement('input');
							
							if ( $( "input[value='PREORDER']" ).length == 0) {
								create_line_item(line_item_preorder, 'properties[PREORDER]', 'PREORDER');
								create_line_item(lineItemProrderEstimate, 'properties[preorderestimate]', preOrderEstimate) 
							}
							
							var standardShip = $('.js-standard').text();
							localStorage.setItem("standard", standardShip);
							var expressShip = $('.js-express').text();
							localStorage.setItem("express", expressShip);

	 					}, 2000);
					} else {
						document.querySelector('.pre-order-note').style.display = 'none';
						$( "input[value='PREORDER']" ).remove();
						$("input[name='properties[_preorderestimate]']").remove();
					}
				}

				function trigger_update (scope, variant, is_custom) {
					//$add_to_cart.style.pointerEvents = 'auto';
					scope.$container.trigger({
						type: 'variantChange',
						variant: variant
					});
					if (!variant) return;
					scope._updateMasterSelect(variant);
					scope._updateImages(variant);
					scope._updatePrice(variant);
					scope.currentVariant = variant;
					if (scope.enableHistoryState) scope._updateHistoryState(variant);
					if (is_custom) {
						if (variant.available == true) {
							$('#addCartBtn').prop('disabled', false).val('add to bag').css('cursor', 'pointer');
						} else {
							$('#addCartBtn').prop('disabled', true).val('sold out').css('cursor', 'default');
						}
					}
				}

				function create_line_item (node, name, value) {
					node.name = name;
					if (value) node.setAttribute('value', value);
					node.setAttribute('hidden', true);
					$product_form.appendChild(node);
				}

				function create_darestock_form (node, v_id, p_id, url) {
					if (document.getElementById('da-restock-notification-variant-' + v_id)) {
						document.getElementById('da-restock-notification-variant-' + v_id).style.display = 'block';
						return;
					}
					node.classList.add('da-restock-notification');
					node.setAttribute('id', 'da-restock-notification-variant-' + v_id);
					node.style.display = 'block';
					node.innerHTML = '<form action="" method="post">' +
						'<p>Enter your email address below to find out when this item will be available!</p>' +
						'<input type="text" placeholder="Email Address" name="email">' +
						'<input type="hidden" name="store" value="cariuma.myshopify.com">' + // domain
						'<input type="hidden" name="product" value="' + p_id + '">' + // product id
						'<input type="hidden" name="url" value="' + url + '">' + // handle
						'<input type="hidden" id="da-restock-variant" name="variant" value="' + v_id + '">' + // variant id
						'<button class="btn" type="submit" name="submit">Waitlist</button>' +
					'</form>'
					document.getElementById('dd-restock-notification-container').appendChild(node);
				}

				/* Match the Selected value with Properties Created  */
				
				var selectedVar = $('.dropdown .selected .size').text();
				var value_input = $("input[name*='properties[size]']").val();
				var value_matched = value_input.includes(selectedVar);


				/* If Value is matched with property then remove class from ATC */
				if (value_matched == true) {
					//$add_to_cart.classList.remove('btn--disabled');
				}
			},

			/**
			 * Trigger event when variant image changes
			 *
			 * @param  {object} variant - Currently selected variant
			 * @return {event}  variantImageChange
			 */
			_updateImages: function(variant) {
				var variantImage = variant.featured_image || {};
				var currentVariantImage = this.currentVariant.featured_image || {};

				if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
					return;
				}

				this.$container.trigger({
					type: 'variantImageChange',
					variant: variant
				});
			},

			/**
			 * Trigger event when variant price changes.
			 *
			 * @param  {object} variant - Currently selected variant
			 * @return {event} variantPriceChange
			 */
			_updatePrice: function(variant) {
				if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
					return;
				}

				this.$container.trigger({
					type: 'variantPriceChange',
					variant: variant
				});
			},

			/**
			 * Update history state for product deeplinking
			 *
			 * @param {object} variant - Currently selected variant
			 */
			_updateHistoryState: function(variant) {
				if (!history.replaceState || !variant) {
					return;
				}
				
				// if(globalTrackVariant !== variant.id){
				// 	globalTrackVariant = variant.id
				// 	console.log(globalTrackVariant, 'passed')
				// 	$add_to_cart.classList.remove('btn--disabled');
				// 	console.log('button Disabled class removed');
				// } else {
				// 	alert('Something is wrong, please refresh your browser!')
				// 	$add_to_cart.classList.add('btn--disabled');
				// }

				$add_to_cart.classList.remove('btn--disabled');

				var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
				window.history.replaceState({path: newurl}, '', newurl);
			},

			/**
			 * Update hidden master select of variant change
			 *
			 * @param {object} variant - Currently selected variant
			 */
			_updateMasterSelect: function(variant) {
				$(this.originalSelectorId, this.$container)[0].value = variant.id;
			}
		});

		return Variants;
	})();

	$('.catiba-high-add-to-cart').on('click', () => {
		const freeInsole = window.freeInsoleData;
		let currentSize; 
		let isAlreadyInCart = false;
		let updateIndex;
		let currentFakeQuantity;
		const cartItems = CartJS.cart.items;
		
		const foundFreeInsoleVariant = freeInsole.variants.find(each => {
			if(each.option3 == currentSelectedSize && each.option1 === currentSelectedGender){
				return each;
			} else{
				return undefined;
			}
		})

		if($('input[name="properties[size]"]').length > 0){
			currentSize = $('input[name="properties[size]"]').attr('value');
		}

		if(foundFreeInsoleVariant && foundFreeInsoleVariant.inventory_quantity > 0){
			for(let i = 0; i < cartItems.length; i++){
				const current = cartItems[i];
				if(current.id == foundFreeInsoleVariant.id && current.properties._linkWith == currentVariant.id){
					isAlreadyInCart = true;
					currentFakeQuantity = current.properties.freeInsoleCount;
					updateIndex = i + 1;
					break;
				}
			}

			const productInput = document.createElement('input');
			productInput.setAttribute('name', "properties[_linkWithInsole]");
			productInput.setAttribute('value', foundFreeInsoleVariant.id);
			productInput.setAttribute('hidden', true);
			$product_form.appendChild(productInput);

			if(isAlreadyInCart){
				currentFakeQuantity = parseInt(currentFakeQuantity) + 1;
				console.log(currentFakeQuantity);
				CartJS.updateItem(updateIndex, undefined,  {
					"size": currentSize,
					'_linkWith': currentVariant.id,
					'freeInsoleCount': currentFakeQuantity,
				},
					{
						"error": function(jqXHR, textStatus, errorThrown){
							// console.log("HELLO")	
						},
						"success": function(jqXHR, textStatus, errorThrown){
							// console.log("SSS")		
						},
				});
			} else {
				CartJS.addItem(foundFreeInsoleVariant.id, 1, {
					"size": currentSize,
					'_linkWith': currentVariant.id,
					'freeInsoleCount': 1,
				})
			}
		}
	})
	
}